import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'

interface SubItem {
  icon: ReactNode
  label: string
  href: string
}

interface DropdownNavItemProps {
  icon: ReactNode
  label: string
  isCollapsed: boolean
  isExpanded: boolean
  onClick: () => void
  mainHref?: string
  subItems: SubItem[]
}

export function DropdownNavItem({
  icon,
  label,
  isCollapsed,
  isExpanded,
  onClick,
  mainHref,
  subItems
}: DropdownNavItemProps) {
  const mainContent = (
    <div
      onClick={onClick}
      className={cn(
        "group flex items-center rounded-lg py-2 text-sm font-medium transition-colors cursor-pointer",
        "text-sidebar-foreground dark:text-sidebar-foreground hover:bg-sidebar-accent/50 dark:hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground dark:hover:text-sidebar-accent-foreground"
      )}
    >
      <div className="flex h-8 w-10 shrink-0 items-center justify-center">
        <div className="h-5 w-5">{icon}</div>
      </div>
      <div 
        className={cn(
          "flex-1 flex items-center justify-between overflow-hidden transition-all duration-300",
          isCollapsed ? "w-0 opacity-0" : "w-auto opacity-100 pr-3"
        )}
      >
        <span className="truncate">{label}</span>
        <ChevronDown 
          className={cn(
            "h-4 w-4 transition-transform duration-200",
            isExpanded ? "rotate-180" : "rotate-0"
          )} 
        />
      </div>
    </div>
  )

  return (
    <div className="relative">
      {mainHref ? (
        <Link to={mainHref}>{mainContent}</Link>
      ) : (
        mainContent
      )}
      
      {!isCollapsed && isExpanded && (
        <div className="ml-4 mt-1 space-y-1">
          {subItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "group flex items-center rounded-lg py-2 text-sm font-medium transition-colors",
                "text-sidebar-foreground dark:text-sidebar-foreground hover:bg-sidebar-accent/50 dark:hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground dark:hover:text-sidebar-accent-foreground"
              )}
            >
              <div className="flex h-8 w-10 shrink-0 items-center justify-center opacity-75">
                <div className="h-4 w-4">{item.icon}</div>
              </div>
              <span className="truncate">{item.label}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
} 